import { BrandConfig } from './brandConfig';
import ameland from './brandConfig.ameland';
import campercontact from './brandConfig.campercontact';
import mock from './brandConfig.mock';
import oberon from './brandConfig.oberon';
import qualitylodgings from './brandConfig.qualitylodgings';
import schier from './brandConfig.schier';
import visitwadden from './brandConfig.visitwadden';
import wadden from './brandConfig.wadden';
import waterland from './brandConfig.waterland';
import zandvoort from './brandConfig.zandvoort';

const brandConfigs: Record<string, BrandConfig> = {
    ameland,
    campercontact,
    mock,
    oberon,
    qualitylodgings,
    schier,
    visitwadden,
    wadden,
    waterland,
    zandvoort,
};

export default brandConfigs;
